import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { TooltipPosition } from '@angular/material/tooltip';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {
  isEnabled = input(true);
  buttonTextLabelPath = input<string>('');
  buttonIconPath = input<string | undefined>(undefined);
  tooltipPosition = input<TooltipPosition>('left');
  disabledTooltipText = input<string | undefined>(undefined);
  buttonClicked = output<void>();

  public handleClick(): void {
    this.buttonClicked.emit();
  }
}
